import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FormControlLabel, Grid, Switch, TablePagination } from '@material-ui/core';
import { facturasAfiliadoLimpiar, fetchCtaCtePorAfiliado } from "../../../actions/facturacion/facturasAfiliado";
import { ListaCtaCte } from "./ListaCtaCte";

export const ConsultaCtaCte = () => {
    const dispatch = useDispatch();
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(0);
    const [dense, setDense] = useState(true);

    const { items, cargada } = useSelector((state) => state.facturasAfiliado);
    const { consultaAfiliado } = useSelector((state) => state.afiliacion);

    useEffect(() => {
        dispatch( facturasAfiliadoLimpiar() );
        dispatch( fetchCtaCtePorAfiliado(consultaAfiliado.id_afiliado) );
    }, [dispatch, consultaAfiliado.id_afiliado]);

    useEffect(() => {
        setTotal(items.map(s => s.saldoConInteres).reduce((a, b) => a + b, 0));
    }, [items]);

    const handleChangePage = (e, newPage) => {
        setPage(newPage);
    };
    
    const handleChangeRowsPerPage = (e) => {
        setRowsPerPage(parseInt(e.target.value, 10));
        setPage(0);
    };

    return (
        <Grid container justify="center">
            <Grid item xs={12} sm={4} md={11} style={{ marginTop: 15 }}>
                <ListaCtaCte
                    items={items}
                    cargada={cargada}
                    consultaAfiliado={consultaAfiliado}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    total={total}
                    dense={dense}
                />
            </Grid>
            <Grid item xs={12} sm={4} md={11} style={{ marginTop: 10 }}>
                {cargada&& items.length > 0&&
                    <>
                        <TablePagination
                            style={{backgroundColor: 'white'}}
                            rowsPerPageOptions={[5, 10, 25]}
                            component="div"
                            count={items.length}
                            rowsPerPage={rowsPerPage}
                            labelRowsPerPage='Registros por página'
                            page={page}
                            onChangePage={handleChangePage}
                            onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                        <FormControlLabel
                            control={<Switch checked={dense} onChange={(e) => setDense(e.target.checked)} />}
                            label="Tamaño compacto"
                        />
                    </>
                }
            </Grid>
        </Grid>
    );
}
